/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import Recaptcha from 'react-invisible-recaptcha';
import { Box, Typography, Grid, makeStyles, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import InputField from '../../custom-components/form-fields/inputField';
import { VERIFY_USER, UPDATE_USER } from '../../api-setup/api-endpoints';
import Validation from '../../models/validation';
import { SignUp2Schema } from '../../models/schema';
import SvgBrokenLink from '../../icons/svgBrokenLink';
import ProjectSettings from '../../settings';
import { resendEmailApiCall } from 'lib/common-api-functions';
import { setUserCredential } from 'lib/cookies';
import { removeAllFromQuery } from 'lib/url-utilities';
import { POSTAPI, GETAPI, API } from 'api-setup/api-helper';
import BtnWithLoader from 'custom-components/btnWithLoader';
import { useDispatch } from 'react-redux';
import { setNewMessage } from 'redux/actions/setting-actions';
import { Lock, Briefcase } from 'react-feather';
import PreLoader from 'custom-components/preloader';
import mixPanel from 'lib/mix-panel';
import CustomToolTip from 'custom-components/customToolTip';
import VSvgLockIcon from '../../icons/VSvgLockIcon';
import { SuitcaseIcon } from '@phosphor-icons/react';
import useAuthStyles from './styles';
import { MAX_PASSWORD_LENGTH } from 'constants/common';


const useStyles = makeStyles((theme) => ({
  emailVeriFailedWrap: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    // background: 'white',
  },
  iconColor: {
    color: `${theme.palette.text.primary} !important`,
  },
}));

// handles validations for form fields
const handleValidations = (formFields) => {
  let newErrObj = '';
  newErrObj = Validation.validate(SignUp2Schema, formFields);
  if (newErrObj) return newErrObj;
  return false;
};

// api call for posting organisation and password
const updateApiCall = (
  captchaToken,
  recaptchaRef,
  token,
  formFields,
  history,
  setIsLoading,
  dispatch
) => {
  const { organizationName, password, confirmPassword } = formFields;
  const body = {
    data: {
      organisation: organizationName,
      password,
      confirm_password: confirmPassword,
      captchaToken,
    },
  };
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  POSTAPI(false, UPDATE_USER, null, headers, body)
    .then((res) => {
      if (res.data.status === API.apiSuccessStatus) {
        const { token: newToken } = res.data.data;
        setUserCredential({
          authToken: newToken,
        });
        dispatch(
          setNewMessage({ message: 'Success! Your Account is active', type: 'success', show: true })
        );
        history.replace('/events');
      } else {
        API.errStatusHandler(res, history, dispatch, () => {
          if (
            process.env.REACT_APP_ENV_TYPE === 'stg' ||
            process.env.REACT_APP_ENV_TYPE === 'prod'
          ) {
            if (recaptchaRef && recaptchaRef.current) {
              recaptchaRef.current.reset();
            }
          }
          setIsLoading(false);
        });
      }
    })
    .catch((err) => {
      API.catchHandler(err, () => {
        if (process.env.REACT_APP_ENV_TYPE === 'stg' || process.env.REACT_APP_ENV_TYPE === 'prod') {
          if (recaptchaRef && recaptchaRef.current) {
            recaptchaRef.current.reset();
          }
        }
      });
      setIsLoading(false);
    });
};

export default function VerifyToken(props) {
  const { emailVeriFailedWrap, iconColor } = useStyles();
  const { authBtn, primaryBtn, authInputStyles, formContainer, formInputBox, pageContainer, titleBox, titleText } = useAuthStyles();

  const [isEmailLinkExpired, setEmailLinkExpired] = useState(false);
  const [isAccountActivated, setAccountActivated] = useState(false);
  const [isEmailVerificationFailed, setEmailVerificationFailed] = useState(false);
  const [formFields, setFormFields] = useState({
    organizationName: '',
    password: '',
    confirmPassword: '',
  });
  const [captchaToken, setCaptchaToken] = useState('');
  const recaptchaRef = useRef(null);
  const [errObj, setErrObj] = useState('');
  const [token, setToken] = useState('');
  const [isInitLoading, setInitLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const formSubmit = (event) => {
    event.preventDefault();
    const err = handleValidations(formFields);
    if (!err) {
      setErrObj({});
      if (process.env.REACT_APP_ENV_TYPE === 'stg' || process.env.REACT_APP_ENV_TYPE === 'prod') {
        if (recaptchaRef && recaptchaRef.current) {
          recaptchaRef.current.execute();
        }
      } else {
        makeApiCall('');
      }
    } else {
      setErrObj(err);
    }
  };
  useEffect(() => {
    const _token = props.location.search.split('=').pop();
    if (!_token) {
      props.history.replace('/login');
    } else {
      setToken(_token);
      removeAllFromQuery(props.history, props.location);
      const headers = {
        type: 'signup',
        Authorization: `Bearer ${_token}`,
      };
      GETAPI(false, VERIFY_USER, null, headers, null)
        .then((res) => {
          setInitLoading(false);
          if (res.data.type && res.data.type === 'OrganiserLinkExpired Exception') {
            setEmailLinkExpired(true);
          } else if (res.data.is_verified && res.data.is_verified === 1) {
            setAccountActivated(true);
          } else {
            setEmailVerificationFailed(true);
          }
          // mixpanel
          if (isEmailLinkExpired || isEmailVerificationFailed) mixPanel.Login.BrokenSignupLinkMP();
        })
        .catch(API.catchHandler);
    }
    // mixpanel
    mixPanel.Login.RedirectFromEmailMP('FORM');
  }, []);

  // api call for resending email or updating user credentials
  const makeApiCall = (propCaptchaToken = '') => {
    setIsLoading(true);
    if (isEmailLinkExpired) resendEmailApiCall(token, props.history, setIsLoading, dispatch);
    else
      updateApiCall(
        propCaptchaToken,
        recaptchaRef,
        token,
        formFields,
        props.history,
        setIsLoading,
        dispatch
      );
  };

  useEffect(() => {
    if (captchaToken) {
      makeApiCall(captchaToken);
    }
  }, [captchaToken]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrObj({ ...errObj, [name]: '' });
    setFormFields({ ...formFields, [name]: value });
  };
  if (isInitLoading)
    return (
      <Box display="flex" alignItems="center">
        <Box position="relative" width={350} height={350} m="auto">
          <PreLoader />
        </Box>
      </Box>
    );
  return (
    <>
      <Box className={pageContainer}>
        {isEmailLinkExpired || isEmailVerificationFailed ? (
          <Box className={formContainer}>
            <Box className={formInputBox}>
              <Box mb={8} className="text-center">
                <Typography variant="subtitle2" component="h3">
                  That link is no longer valid
                </Typography>
              </Box>
              <Box mt={8} className="text-center" color="text.primary">
                <Box component="span">
                  <SvgBrokenLink />
                </Box>
                <Box mt={5} ml="auto" mr="auto">
                  <Typography variant="body1" component="p">
                    {isEmailLinkExpired
                      ? 'Email confirmation links expire after a while and can only be used once'
                      : 'Invalid Link'}
                  </Typography>
                </Box>
                <Box mt={4}>
                  <Typography color="textPrimary" variant="body1">
                    Already used the link to create your account?{' '}
                    <Link to="/">
                      <Box component="span" color="primary.main" fontWeight={600}>
                        Sign In
                      </Box>
                    </Link>
                  </Typography>
                </Box>

              </Box>
            </Box>
            <Box>
              <BtnWithLoader
                onClick={makeApiCall}
                variant="contained"
                color="primary"
                className={`${authBtn} ${primaryBtn}`}
                disabled={isLoading}
                isLoading={isLoading}
                loadingLabel="Requesting"
                label="Request New link"
                fullWidth
              />
            </Box>
          </Box>
        ) : isAccountActivated ? (
          <Box component='form' className={formContainer}>
            <Box className={formInputBox}>
              <Box component="span" display="flex" justifyContent="center">
                <SvgBrokenLink />
              </Box>
              <Box mt={5} textAlign="center" color="text.primary">
                <Typography variant="body1" component="p">
                  Your account is already activated. You can just log in to your account.
                </Typography>
              </Box>
            </Box>
            <Box>
              <Button
                type="submit"
                onClick={() => props.history.replace('/')}
                fullWidth
                className={`${authBtn} ${primaryBtn}`}
                color="primary"
                variant="contained">
                Login
              </Button>
            </Box>
          </Box>
        ) : (
          <>
            <Box className={titleBox}>
              <Typography variant='h2' className={titleText}>
                Add Account Detail.
              </Typography>
            </Box>
            <form className={formContainer} onSubmit={(event) => formSubmit(event)}>
              <Box className={formInputBox}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <InputField
                      disabled={isLoading}
                      error={errObj.organizationName}
                      name="organizationName"
                      id="organizationName"
                      value={formFields.organizationName}
                      className={authInputStyles}
                      onChange={handleChange}
                      required
                      placeholder="Organization"
                      type="text"
                      startAdornment
                      startIconAdornment
                      startAdornmentIcon={<SuitcaseIcon className={iconColor} />}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Box display="flex" position="relative" width="93%" height="30px">
                      <CustomToolTip
                        isFabIcon
                        title={`Password should be minimum ${MAX_PASSWORD_LENGTH} characters with a combination of Upper, lowercase, digits and special characters.`}
                        placement="top"
                      />
                    </Box>
                    <InputField
                      disabled={isLoading}
                      error={errObj.password}
                      name="password"
                      id="password"
                      onChange={handleChange}
                      className={authInputStyles}
                      value={formFields.password}
                      required
                      placeholder="Password"
                      type="password"
                      startAdornment
                      startIconAdornment
                      startAdornmentIcon={<VSvgLockIcon className={iconColor} />}
                      showFieldVisibilityBtn
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputField
                      disabled={isLoading}
                      error={errObj.confirmPassword}
                      name="confirmPassword"
                      id="confirmPassword"
                      className={authInputStyles}
                      value={formFields.confirmPassword}
                      onChange={handleChange}
                      required
                      placeholder="Confirm password"
                      type="password"
                      startAdornment
                      startIconAdornment
                      startAdornmentIcon={<VSvgLockIcon className={iconColor} />}
                      showFieldVisibilityBtn
                    />
                  </Grid>
                </Grid>
                <Box mt={2} textAlign="right" color="text.primary">
                  <Typography variant="body1" component="p">
                    Already have an account?{' '}
                    <Link to="/">
                      <Box component="span" color="primary.main" fontWeight={600}>
                        Sign In
                      </Box>
                    </Link>
                  </Typography>
                </Box>
              </Box>
              <Box>
                <BtnWithLoader
                  type="submit"
                  className={`${authBtn} ${primaryBtn}`}
                  variant="contained"
                  color="primary"
                  disabled={isLoading}
                  isLoading={isLoading}
                  loadingLabel="Finishing Up"
                  label="Proceed"
                  fullWidth
                />
              </Box>
            </form>
          </>
        )}
      </Box>
      {process.env.REACT_APP_ENV_TYPE === 'stg' || process.env.REACT_APP_ENV_TYPE === 'prod' ? (
        <Recaptcha
          ref={recaptchaRef}
          sitekey={ProjectSettings.recaptchaSiteKey}
          onResolved={(PropToken) => setCaptchaToken(PropToken)}
        />
      ) : (
        ''
      )}
    </>
  );
}
